module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-01.2277d675.png";